<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5">
                            ReAddmission</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">ReAddmission</li>
                                <!-- <li class="breadcrumb-item active" aria-current="page">
                                    {{'header.course-data.titleList.AddCourse' | translate }} </li> -->
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                            </div>
                        </div>
                    </div>

                    <div class="row row-sm add-form" >
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="reAddmission">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div>
                                            <h3 class="main-content-label mb-1"><b>
                                                ReAddmission
                                                </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                               ReAddmission
                                            </p>
                                        </div>
                                        
                                        <div class="row clearfix">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">

                                                        <mat-form-field appearance="outline"  class="example-full-width">
                                                            <mat-label> List</mat-label>
                                                            <mat-select formControlName="list" #select23
                                                                class="colorblack">
                                                                <mat-select-filter *ngIf="select23.focused"
                                                                    [placeholder]="'Filter'"
                                                                    [displayMember]="'data'"
                                                                    [array]="ListOfMarks"
                                                                    (filteredReturn)=" filteredListOfMarks =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of  filteredListOfMarks"
                                                                [value]="item.value" >
                                                                    {{item.data}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>


                                                    </div>
                                                </div>
                                            </div>
                                            <div  class="col-sm-2">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline"  class="example-full-width">
                                                            <mat-label> </mat-label>
                                                            <input class="input"  matInput formControlName="list2" placeholder="" >
                                                       </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div  class="col-sm-4">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline"  class="example-full-width">
                                                            <mat-label> </mat-label>
                                                            <input class="input"  matInput formControlName="list3" placeholder="" >
                                                         </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div  class="col-sm-2">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline"  class="example-full-width">
                                                            <mat-label>Colg </mat-label>
                                                            <input class="input"  matInput formControlName="Colg" placeholder="" >
                                                       </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div  class="col-sm-2">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline"  class="example-full-width">
                                                            <mat-label> Valid</mat-label>
                                                            <input class="input"  matInput formControlName="Valid" placeholder="" >
                                                       </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div  class="col-sm-2">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline"  class="example-full-width">
                                                            <mat-label> Change</mat-label>
                                                            <input class="input"  matInput formControlName="Change" placeholder="" >
                                                       </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                      
                                                <hr>
                                                <div  class="col-sm-3">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <mat-form-field appearance="outline"  class="example-full-width">
                                                                <mat-label> RgNo</mat-label>
                                                                <input class="input"  matInput formControlName="RgNo" placeholder="" >
                                                           </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div  class="col-sm-2"></div>
                                                <div  class="col-sm-2">
                                                    <div class="form-group">
                                                        <div class="">
                                                            <mat-form-field appearance="outline"  class="example-full-width">
                                                                <mat-label> set/Remove ReAdmit</mat-label>
                                                                <input class="input"  matInput formControlName="ReAdmit" placeholder="" >
                                                           </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div  class="col-sm-3"></div>
                                                <div  class="col-sm-2"></div>
                                                    <div  class="col-sm-1">
                                                        <div class="form-group">
                                                            <div class="">
                                                                <mat-form-field appearance="outline"  class="example-full-width">
                                                                    <mat-label> Valid</mat-label>
                                                                    <input class="input"  matInput formControlName="Valid2" placeholder="" >
                                                               </mat-form-field>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div  class="col-sm-4">
                                                        <div class="form-group">
                                                            <div class="">
                                                                <mat-form-field appearance="outline"  class="example-full-width">
                                                                    <mat-label> </mat-label>
                                                                    <input class="input"  matInput formControlName="Valid3" placeholder="" >
                                                               </mat-form-field>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="col-sm-12">
                                                        <button type="button"
                                                            class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                            >Submit</button>
                                                        <!-- <button type="button"
                                                            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                            *ngIf="editButton" (click)="update()">Update</button> -->
                                                        <!-- <button type="button"
                                                            class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                            *ngIf="deleteButton" (click)="DeletetheRecord()">Delete</button> -->
                                                        </div>
                                           
                                        </div>
                                    </div>

                                   
                                    <div class="col-sm-12 pl-0">
                                        <div>
                                            <div class="table-responsive" id="table">
                                                <table class="table table-striped table-bordered ">
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th width="20%" class="f600">
                                                                RgNo
                                                            </th>
                                                            <th width="10%"  class="f600">
                                                                SetRem
                                                            </th>
                                                            <th width="30%"  class="f600">
                                                               Name
                                                            </th>
                                                            <th  width="20%" class="f600">
                                                               Colg
                                                            </th>
                                                            <th  width="10%" class="f600">
                                                               Vld
                                                             </th>
                                                             <th width="10%"  class="f600">
                                                                Chng
                                                             </th>
                                                             <th width="10%"  class="f600">
                                                               Mesg
                                                             </th>
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody >
                                                        <tr>
                                                            <td ></td>
                                                            <td ></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td ></td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <hr>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>

                               
                            </div>
                           
                        </form>
                    </div>
                    <!-- list of Exam end  -->
                </div>
            </div>
        </div>
    </form>
</body>